import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const droppedAction = createAsyncThunk(
    'dropped',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/total-missionqualified`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const droppedSlice = createSlice({
    name: 'dropped',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(droppedAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(droppedAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(droppedAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const droppedReducer = droppedSlice.reducer
